import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Surface } from 'react-native-paper';
import styled from 'styled-components/native';

import Image from '@src/components/Image';
import { windowWidth } from '@src/configuration/constants';
import { Source } from '@src/types';

type CoverProps = {
  size?: number;
};

type Props = {
  source: Source;
  isTour?: Boolean;
  // activeSlide: Boolean;
  onPress?: () => void;
} & CoverProps;

const Cover = styled(Image).attrs({
  resizeMode: 'cover',
})<CoverProps>`
  width: 100%;
  height: ${({ size }) => size || windowWidth / 2}px;
  border-radius: ${({ theme }) => theme.roundness}px;
`;
const IconView = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: grey;
  opacity: 0.3;
  z-index: 10;
  border-radius: 10px;
`;
const CoverContainer = styled(Surface)`
  border-radius: ${({ theme }) => theme.roundness}px;
  elevation: 0;
`;

const Component: React.FC<Props> = ({ source, isTour, onPress, size }) => {
  return (
    <TouchableOpacity activeOpacity={0.8} onPress={onPress}>
      <CoverContainer>
        <Cover size={size} source={source} />
      </CoverContainer>
    </TouchableOpacity>
  );
};

Component.displayName = 'Slide';

export default React.memo(Component);
